import Flippy from "./Flippy";

export { default as Flippy } from './Flippy';
export { FrontSide } from './FlippyCard';
export { BackSide } from './FlippyCard';

export default Flippy;
